import React from 'react';

import { Skeleton } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { spacing } from 'styles/constants';

export const ProductSkeleton = () => {
  return (
    <Box style={styles.container}>
      <Box style={styles.row}>
        <Skeleton rounded={12} w="$24" h="$20" />
        <Box style={styles.details}>
          <Skeleton rounded="full" h="$5" />
          <Box style={styles.metaRow}>
            <Skeleton rounded="full" h="$5" flex={3} />
            <Skeleton rounded="full" h="$5" flex={1} mr="$12" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'flex-start',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  details: {
    flex: 1,
    gap: spacing.$2,
    justifyContent: 'center',
    paddingRight: spacing.$4,
  },
  metaRow: {
    flexDirection: 'row',
    gap: spacing.$2,
  },
  row: {
    flex: 1,
    flexDirection: 'row',
    gap: spacing.$4,
    marginTop: spacing.$3,
  },
});
